import React, { ReactNode } from 'react';
import { PublisherDTO, WorkPublisherDTO, WorkPublisherPlaceDTO } from '../../../../api/core/models';
import { Actions, MultiInputControls } from '../../../components/form/MultiInput/MultiInputControls';
import { ValidationResult } from '../../../../util/validation/interfaces';
import { CheckPermissionFunction } from '../../../../Auth/components/PermissionGate';
import { InputGroup } from '../layout/InputGroup';
import { LabelledInputText } from '../../../components/form/LabelledInputText';
import { Panel } from '../layout/Panel';
import { getDefaultWorkPublisher, getDefaultWorkPublisherPlace } from '../../../../Settings/emptyModels';
import { LabelledPublisherSuggester } from '../../../components/form/LabelledPublisherSuggester';
import { Fieldset } from '../layout/Fieldset';
import { JustifiedDeleteButton } from '../../../components/form/MultiInput/Buttons';
import { WorkPublisherAdd } from './WorkPublisherAdd';


interface PublishersProps {
  checkPermission: CheckPermissionFunction;
  publishers: WorkPublisherDTO[];
  onChange: (publisher: WorkPublisherDTO[]) => void;
  typelist: string;
  validation?: ValidationResult;
  autoFocus: boolean;
}

export function WorkPublishers(props: PublishersProps): ReactNode {
  return (
    <Panel
      title={'work.attr.publishers'}
      toggleable={true}>
      <MultiInputControls<WorkPublisherDTO>
        canEdit={props.checkPermission().canWrite}
        addNew={(publishers: WorkPublisherDTO[]): number => publishers.push(getDefaultWorkPublisher())}
        lines={props.publishers}
        onChange={props.onChange}
        renderLines={(workPublisher: WorkPublisherDTO, onLineChange: (newValue: WorkPublisherDTO) => void, actions: Actions, idx: number): React.ReactNode => {
          return (
            <Fieldset title={'work.attr.publisher'}>
              <LabelledPublisherSuggester
                id={`publisher-${idx}-publisher`}
                autoFocus={props.autoFocus}
                value={workPublisher.publisher ? [workPublisher.publisher] : []}
                multiple={false}
                permissions={props.checkPermission('publisher')}
                onChange={(publisher: PublisherDTO[]): void => onLineChange({
                  ...workPublisher,
                  publisher: publisher.length > 0 ? publisher.pop() : undefined,
                })}

                validation={props.validation.children[idx].fields.publisher}
                label={`work.attr.publisher.attr.publisher`}
              />
              <WorkPublisherAdd
                permissions={props.checkPermission('publisher')}
                onSubmit={(publisher: PublisherDTO): void => onLineChange({...workPublisher, publisher})}
              />
              <Fieldset title={'work.attr.publisher.attr.places'}>
                <MultiInputControls<WorkPublisherPlaceDTO>
                  canEdit={props.checkPermission('work_publisher_place').canWrite}
                  addNew={(places: WorkPublisherPlaceDTO[]): number => places.push(getDefaultWorkPublisherPlace())}
                  renderLines={(workPlace: WorkPublisherPlaceDTO, onChange2: (newValue: WorkPublisherPlaceDTO) => void, placeActions: Actions, placeIdx: number): React.ReactNode => {
                    return <InputGroup delete={{
                      action: placeActions.delete,
                      disabled: !props.checkPermission('work_publisher_place').canWrite,
                    }}>
                      <LabelledInputText
                        id={`publisher-${idx}-places-${placeIdx}-place`}
                        autoFocus={props.autoFocus}
                        value={workPlace.place}
                        onChange={(place: string): void => onChange2({...workPlace, place})}
                        label={'work.attr.publisher.attr.place'}
                        permissions={props.checkPermission('work_publisher_place.place')}
                        validation={props.validation.children[idx].fields.work_publisher_place.children[placeIdx].fields.place}
                      />
                    </InputGroup>;
                  }}
                  lines={workPublisher.workPublisherPlace}
                  onChange={(workPublisherPlace: WorkPublisherPlaceDTO[]): void => onLineChange({
                    ...workPublisher,
                    workPublisherPlace,
                  })}
                />
              </Fieldset>
              <JustifiedDeleteButton onClick={actions.delete} disabled={!props.checkPermission().canWrite}/>
            </Fieldset>
          );
        }}
      />
    </Panel>
  );
}
